@import '../../styles/prose.css';

:host {
  display: block;
  min-width: 0;
  color: inherit;
  box-sizing: border-box;
  -webkit-user-select: text;
  user-select: text;
}
